<div class="view-wrapper">

  <mb-mpup-header></mb-mpup-header>

  <div class="container">
    <div class="top-container">

      <div class="navigation-wrapper">
        <mb-mpup-navigation></mb-mpup-navigation>
      </div>
      <div class="contact-link-container">
        <img src="assets/images/Icon_speech_bubble.svg" [alt]="'mpupContact.getInTouch' | mbTranslate"/>
        <button class="contact-link" (click)="viewportScroller.scrollToAnchor('contact')">
          {{'mpupContact.getInTouch' | mbTranslate}}
        </button>
      </div>

      <div class="d-flex justify-content-between flex-shrink-0 w-100" [ngClass]="{'align-items-end': fridges.length > 1, 'align-items-center': fridges.length === 1}">
        <div class="mpup-select-container d-flex flex-column align-items-start justify-content-end flex-md-row justify-content-md-start align-items-md-center w-auto">
          <h2 class="inventory-heading">{{'mpupInventory.inventoryHeading' | mbTranslate}}</h2>

          <mb-mpup-fridge-select
            [fridges]="fridges"
            (selectFridge)="updateSelectedFridge($event)"
            [selectedFridge]="selectedFridge$.getValue()"
          ></mb-mpup-fridge-select>
        </div>

        <mb-mpup-search
          class="search"
          (search)="searchInventoryList($event)"
          [placeholder]="'mpupInventory.placeholder' | mbTranslate"
        >
        </mb-mpup-search>

      </div>
    </div>

    <div class="results-container">
      <div class="inventory-list-container">
        <ng-container *ngIf="!(getLoading() | async) && listItems.length > 0">
          <p class="sort-description">{{'mpupInventory.sortedByCatalog' | mbTranslate}}</p>
          <mb-mpup-inventory-list-item *ngFor="let item of listItems" [item]="item"></mb-mpup-inventory-list-item>
        </ng-container>

        <div class="centered-message" *ngIf="getLoading() | async">
          <cx-spinner></cx-spinner>
        </div>
        <span class="loading-spinner-message" *ngIf="getLoading() | async">{{'mpupInventory.loadingMessage' | mbTranslate}}</span>

        <span class="centered-message" *ngIf="listItems.length === 0 && !(getLoading() | async)">{{'mpupInventory.noResultsFound' | mbTranslate}}</span>
      </div>

      <div class="pagination-wrapper">
        <span>{{getPaginationText()}}</span>
        <cx-pagination [pagination]="paginationStatistics$.getValue()" (viewPageEvent)="changePage($event)"></cx-pagination>
      </div>
    </div>

    <div id="contact">
      <mb-mpup-contact-info [contact]="selectedFridge$.getValue()?.country || 'DE'"></mb-mpup-contact-info>
    </div>
  </div>
</div>
